import {SidebarMenuItem} from './SidebarMenuItem'

const SidebarMenuMainKorca = () => {
  return (
    <>
      <SidebarMenuItem to='/apps/program-affiliate/dashboard' title='Korca' hasBullet={true} />
      {/* <SidebarMenuItem
        to='/apps/direction-screen/dashboard'
        title='Direksi Dashboard'
        hasBullet={true}
      />
      <SidebarMenuItem
        to='/apps/korca-member-management/korca-member'
        title='Korca Member'
        hasBullet={true}
      /> */}
    </>
  )
}

export default SidebarMenuMainKorca
